<template>
  <div class="px-5">
    <v-row align="center" align-content="center" class="pt-4">
      <v-col style="font-weight: 100;" class="text-center">
        <v-icon large color="widgetText" style="opacity: 0.6">
          mdi-exclamation
        </v-icon>
      </v-col>
    </v-row>
    <v-row align-content="center">
      <v-col class="text-center widgetText--text" style="font-weight: 100;">
        <span :style="{fontSize: '16px', opacity: '0.6', fontWeight: '400', wordBreak:'break-word'}">
          {{ text }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'BaseTextInfo',
  props: {
    text: { type: String, default () { return 'placeholder' } },
  },
}
</script>
